import { ExternalLayerInfoDc } from "@evergis/api";
import { TreeItemProps } from "@evergis/ui";
import { Dispatch, SetStateAction } from "react";
import { ResourceMeta, ResourceMetaUpdate } from "../../../../hooks/useResourceMeta";

export enum ProxyServiceType {
  WMS = "WMS",
  ArcGIS = "ArcGIS",
  TMS = "TMS",
}

export enum AddProxyServiceStep {
  Type,
  Layers,
  Meta,
  Finish,
}

export type AddProxyServiceContextType = {
  step?: number;
  setStep?: Dispatch<SetStateAction<number>>;
  serviceType?: ProxyServiceType;
  setServiceType?: (serviceType: ProxyServiceType) => void;
  sourceUrl?: string;
  setSourceUrl?: (sourceUrl: string) => void;
  meta?: ResourceMeta;
  updateMeta?: ResourceMetaUpdate;
  layers?: string[];
  setLayers?: (layers: string[]) => void;
  subDomainsValue?: string;
  setSubDomainsValue?: (subDomainsValue: string) => void;
  layersData?: ExternalLayerInfoDc[];
  layersLoading?: boolean;
  layersError?: Error;
  treeData?: TreeItemProps[];
  importLayers?: VoidFunction;
};
